
import Vue from 'vue'
import CreditDepositCard from '../credit-deposit-card/index.vue'
import TabDefault from '~/components/ui/tab/tab-default.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'CreditDepositCardList',
  components: {
    CreditDepositCard,
    TabDefault
  },
  mixins: [staticBlockMixin],
  computed: {
    titleValue () {
      return this.useHeader ? this.title : this.mainFields.title?.value
    }
  },
  methods: {
    getBlockProperties (fields: { [key: string]: any }, key: string) {
      return Object.entries(fields)?.reduce((acc, curr) => {
        if (curr[0].includes(key)) { acc.push(curr[1]) }
        return acc
      }, [] as any[])
    }
  }
})
